module.exports = __webpack_public_path__ + "static/img/page_PLAY01.83db201.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/_course/series6-moocs/course2/page_PLAY01.png
// module id = AF5w
// module chunks = 0